import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { useState } from 'react';
import { getSize } from '@lib/common';
import { BaseQuestionAnswerComponent } from '../../../bases';
import styled from '@xstyled/styled-components';
import { Checkbox } from 'antd';
import { useQuestionContext } from '../../../core';
import { AnswerItem } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAnswerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAnswerGroup = styled(Checkbox.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  width: 100%;\n"])), getSize('padding12'));
export var MultipleChoiceAnswerComponent = function MultipleChoiceAnswerComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var correctAnswerIds = states.correctAnswerIds;
  var onSelectedAnswers = actions.onSelectedAnswers;

  var _useState = useState([]),
      selectedAnswerIds = _useState[0],
      setSelectedAnswerIds = _useState[1];

  var handleSelectAnswerChange = function handleSelectAnswerChange(e) {
    setSelectedAnswerIds(e);
    onSelectedAnswers === null || onSelectedAnswers === void 0 ? void 0 : onSelectedAnswers(e);
  };

  return /*#__PURE__*/_jsx(BaseQuestionAnswerComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsx(StyledAnswerContainer, {
      children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
        value: selectedAnswerIds.length > 0 ? selectedAnswerIds : correctAnswerIds,
        onChange: handleSelectAnswerChange,
        children: question.answers.map(function (answer, index) {
          return /*#__PURE__*/_jsx(AnswerItem, {
            answer: answer,
            index: index,
            readonly: false,
            isShowCorrectAnswer: false,
            isSelected: selectedAnswerIds.includes(answer.id.toString())
          }, answer.id.toString());
        })
      })
    })
  });
};